<template>
    <div style="position: relative;">
        <NavbarScheduledReport
            :profile="profile"
            @save="onSubmit"
            @cancel="onCancel"
        />
        <content-wrapper>
            <div class="page-content">
                <breadcrumb class="px-0 bg-light pb-0" :items="breadcrumbs" />

                <b-card footer-class="p-0" class="rounded-lg mt-4">
                    <ScheduledReportsForm
                        ref="scheduled-report-form"
                        @is-edit-mode="onEditMode"
                        @save="onSubmit"
                        @cancel="onCancel"
                    />
                </b-card>
            </div>
        </content-wrapper>
    </div>
</template>
<script>
import ContentWrapper from "@/module/layout/content-wrapper.vue";
import ScheduledReportsForm from "@/module/report/scheduled/form.vue";
import ScheduledReportService from "@/services/report/scheduled";
import NavbarScheduledReport from "@/module/report/scheduled/navbar.vue";
import Breadcrumb from "@/components/commons/breadcrumb.vue";
import { TAB_STRING } from "@/constants/tab-report";
const MODE_EDIT = "EDIT";
const MODE_NEW = "NEW";

export default {
    components: {
        ScheduledReportsForm,
        NavbarScheduledReport,
        Breadcrumb,
        ContentWrapper
    },
    computed: {
        title() {
            return this.profile.mode === MODE_EDIT
                ? "Edit Scheduled Report"
                : "Create Scheduled Report";
        },
        breadcrumbs() {
            return [
                {
                    text: "Reports",
                    to: {
                        name: "report_dashboard"
                    }
                },
                {
                    text: `Scheduled Reports`,
                    to: {
                        name: "report_dashboard",
                        query: {
                            tab: TAB_STRING.SCHEDULED_REPORT
                        }
                    }
                },
                {
                    text: this.edittedScheduledReport
                        ? this.edittedScheduledReport.reportName
                        : "New",
                    to: ""
                }
            ];
        }
    },
    data() {
        return {
            edittedScheduledReport: null,
            isReady: false,
            profile: {
                mode: MODE_NEW,
                isSaving: false,
                isLetterEdit: false
            }
        };
    },
    async created() {},
    methods: {
        onEditMode(edittedScheduledReport) {
            this.profile.mode = edittedScheduledReport ? MODE_EDIT : MODE_NEW;
            this.edittedScheduledReport = edittedScheduledReport;
        },
        async onSubmit({ addNew }) {
            const isValid = await this.$refs[
                "scheduled-report-form"
            ].validateForm();

            if (!isValid) {
                return;
            }
            this.isSaving = true;
            const form = this.$refs["scheduled-report-form"].data;

            let dateRange = form.date_range;
            if (!form.report.isShowDateRange) {
                dateRange = 0; // The report has no date range
            }

            const filters = {
                ...form.filters,
                date_range: dateRange,
                export_scope: form.export_scope
            };

            const payload = {
                report_id: !form.report.isCustom ? form.report.reportId : null,
                scheduled_report_name: form.scheduled_report_name,
                custom_report_id: form.report.isCustom
                    ? form.report.reportId
                    : null,
                filters: filters,
                export_type: form.export_type,
                report_date: form.report_date,
                recurring: form.recurring,
                send_type: form.send_type,
                recipients: {
                    actor_id: form.recipients.map(recipient => recipient.id)
                }
            };

            console.log("Form submitted:", { payload, addNew, form });

            if (form.id !== null) {
                // update logic here
                await this.updateScheduledReport(form.id, payload);
            } else {
                // create logic here
                await this.createScheduledReport(payload);
            }

            this.isSaving = false;

            // Optionally redirect or show notification
        },
        onCancel() {
            this.$router.push({
                name: "report_dashboard",
                query: { tab: TAB_STRING.SCHEDULED_REPORT }
            });
        },
        // CODE API CREATE HERE
        async createScheduledReport(payload) {
            try {
                const response = await ScheduledReportService.create(payload);
                if (response?.code === 200) {
                    this._message("Scheduled report created successfully");
                    // Redirect to the list page or edit mode
                    this.$router.push({
                        name: "report_dashboard",
                        query: { tab: TAB_STRING.SCHEDULED_REPORT }
                    });
                } else {
                    throw new Error("Failed to create scheduled report");
                }
            } catch (error) {
                console.error("Error creating scheduled report:", error);
                this._message("Failed to create scheduled report", "danger");
            }
        },
        async updateScheduledReport(scheduledReportId, payload) {
            try {
                const response = await ScheduledReportService.update(
                    scheduledReportId,
                    payload
                );
                if (response?.code === 200) {
                    this._message("Scheduled report updated successfully");
                    // Optionally refresh the data or redirect
                    this.$router.push({
                        name: "report_dashboard",
                        query: { tab: TAB_STRING.SCHEDULED_REPORT }
                    });
                } else {
                    throw new Error("Failed to update scheduled report");
                }
            } catch (error) {
                console.error("Error updating scheduled report:", error);
                this._message(
                    "An error occurred while updating the scheduled report",
                    "danger"
                );
            }
        }
    }
};
</script>
